function make(hosts) {
    // Object.keys(hosts).map(key => (hosts[key] += `/${process.env.version}`));
    return hosts;
}

// const testdomain = 'api'
const dytestdomain = 'dyapi';
const moneydomain = '/money';

const pdomain = `https://gateway.chongnengjihua.com`;
const domain = `https://test-gateway.jinyi999.cn`;
let hqdomain = `https://hq.chongnengjihua.com`;
// const prodDomain = `//gateway.jinyi999.cn`;

// const general = {
//   mock: `http://${domain}`
// };

const dev = {
    apihqDomain: 'https://test-api-hq.jinyi999.cn',
    // stockQuoteHost: `${domain}/rjhy-stock-quote/api/1`,
    rankHost: `${domain}/rjhy-stock-rank/api/1/biz`,
    gmgQuoteHost: `${domain}/rjhy-gmg-quote/api/1`,
    rjhyQuoteHost: `${domain}/rjhy-stock-quote/api/1`,
    rjhyNewsHost: `${domain}/rjhy-news/api`,
    stockQuoteHost: `${domain}/rjhy-stock-quote/api/1`,
    stockDiagnosisHost: `${domain}/rjhy-stock-diagnosis/api/1`,
    quotes: `${dytestdomain}`,
    money: `${moneydomain}`,
    circle: `${domain}/rjhy-circle/api/1`,
    sms: `${domain}/rjhy-sms/api/1`,
    user: `${domain}/rjhy-user/api/1`,
    rzrq: `${domain}/rjhy-stock-quote/api/1`,
    plateChart: `${domain}/rjhy-stock-rank/api/1`,
    rjhyQuoteSector: `${domain}/rjhy-quote-sector/api/1`,
    file: `${domain}/rjhy-file/api/1`,
    doNews: 'https://test-api.techgp.cn/gw',
    hqToken: 'https://test-hqpassport.9fh5.com',
    hqInfo: 'https://test-infocenter.9fh5.com',
    plateBasic: 'https://test-api.techgp.cn/gw/rjhy-quote-sector/api/1',
    tokenConfig: {
        "AppKey": "jf",
        "AppSecret": "6dff2f6b-5d0c-433e-9355-95a0be35d04b",
        "Name": "jfztgw",
        "Desc": "九方智投官网",
        "Version": "1.0.0",
        "Type": "h5"
    }
};

const test = {
    apihqDomain: 'https://test-api-hq.jinyi999.cn',
    rankHost: `${domain}/rjhy-stock-rank/api/1/biz`,
    gmgQuoteHost: `${domain}/rjhy-gmg-quote/api/1`,
    rjhyQuoteHost: `${domain}/rjhy-stock-quote/api/1`,
    rjhyNewsHost: `${domain}/rjhy-news/api`,
    stockQuoteHost: `${domain}/rjhy-stock-quote/api/1`,
    stockDiagnosisHost: `${domain}/rjhy-stock-diagnosis/api/1`,
    quotes: `${dytestdomain}`,
    money: `${moneydomain}`,
    circle: `${domain}/rjhy-circle/api/1`,
    sms: `${domain}/rjhy-sms/api/1`,
    user: `${domain}/rjhy-user/api/1`,
    rzrq: `${domain}/rjhy-stock-quote/api/1`,
    plateChart: `${domain}/rjhy-stock-rank/api/1`,
    rjhyQuoteSector: `${domain}/rjhy-quote-sector/api/1`,
    file: `${domain}/rjhy-file/api/1`,
    doNews: 'https://test-api.techgp.cn/gw',
    hqToken: 'https://test-hqpassport.9fh5.com',
    hqInfo: 'https://test-infocenter.9fh5.com',
    plateBasic: 'https://test-api.techgp.cn/gw/rjhy-quote-sector/api/1',
    tokenConfig: {
        "AppKey": "jf",
        "AppSecret": "6dff2f6b-5d0c-433e-9355-95a0be35d04b",
        "Name": "jfztgw",
        "Desc": "九方智投官网",
        "Version": "1.0.0",
        "Type": "h5"
    }
};

const preview = {};

const production = {
    apihqDomain: 'https://api-hq.chongnengjihua.com',
    // https://stockhq-aliyun.caixun99.com/curhq/QueryStockPriceVolume
    // stockQuoteHost: `${pdomain}/rjhy-stock-quote/api/1`,
    rankHost: `${hqdomain}/rjhy-stock-rank/api/1/biz`,
    gmgQuoteHost: `${hqdomain}/rjhy-gmg-quote/api/1`,
    rjhyQuoteHost: `${hqdomain}/rjhy-stock-quote/api/1`,
    rjhyNewsHost: `${pdomain}/rjhy-news/api`,
    stockQuoteHost: `${hqdomain}/rjhy-stock-quote/api/1`,
    stockDiagnosisHost: `${hqdomain}/rjhy-stock-diagnosis/api/1`,
    quotes: `${dytestdomain}`,
    money: `${moneydomain}`,
    circle: `${pdomain}/rjhy-circle/api/1`,
    sms: `${pdomain}/rjhy-sms/api/1`,
    user: `${pdomain}/rjhy-user/api/1`,
    rzrq: `${hqdomain}/rjhy-stock-quote/api/1`,
    plateChart: `${hqdomain}/rjhy-stock-rank/api/1`,
    rjhyQuoteSector: `${hqdomain}/rjhy-quote-sector/api/1`,
    file: `${pdomain}/rjhy-file/api/1`,
    doNews: 'https://api.9fzt.com/gw',
    hqToken: 'https://hqpassport.sylapp.cn',
    hqInfo: 'https://infocenter.9fzt.com',
    plateBasic: 'https://api.9fapi.cn/gw/rjhy-quote-sector/api/1',
    tokenConfig: {
        "AppKey": "jf",
        "AppSecret": "beff3635-8c86-42c3-a157-637db2c52554",
        "Name": "jfztgw",
        "Desc": "九方智投官网",
        "Version": "1.0.0",
        "Type": "h5"
    }
};

module.exports = env => {
    console.log('env', env);
    return make(
        {
            dev,
            test,
            preview,
            production,
        }[env]
    );
};
